import React, { useState, useEffect } from 'react';
import { Eye, List, Settings, AlertCircle } from 'lucide-react';
import { usePermissionsContext } from '../../../contexts/PermissionsContext';
import CalendarConfig from './CalendarConfig';
import CalendarEventsList from './CalendarEventsList';
import CalendarView from './CalendarView';
import { useCalendar } from '../../../hooks/useCalendar';

export default function CalendarModule({ currentUser }) {
  const { can } = usePermissionsContext();
  const [activeTab, setActiveTab] = useState('view');

  const {
    config,
    events,
    loading,
    error,
    loadConfig,
    loadEvents,
    saveConfig,
    createEvent,
    updateEvent,
    deleteEvent
  } = useCalendar();

  useEffect(() => {
    loadConfig();
    loadEvents({ anio: new Date().getFullYear() });
  }, []);

  const canManage = can('CONFIG_EDIT');

  const TABS = [
    { id: 'view',   label: 'Calendario'       },
    { id: 'events', label: 'Eventos y Feriados' },
    ...(canManage ? [{ id: 'config', label: 'Configuración' }] : []),
  ];

  return (
    <div className="space-y-6">

      {/* Tabs */}
      <div className="flex gap-1 bg-gray-100 p-1 rounded-xl w-fit">
        {TABS.map(({ id, label }) => (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            className={`px-5 py-2 rounded-lg text-sm font-medium transition-all whitespace-nowrap ${
              activeTab === id
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Error */}
      {error && (
        <div className="flex items-start gap-3 bg-red-50 border border-red-200 rounded-xl p-4 text-sm text-red-700">
          <AlertCircle size={18} className="mt-0.5 shrink-0" />
          <div>
            <p className="font-medium">Error al cargar datos</p>
            <p className="text-xs mt-0.5 opacity-80">{error}</p>
          </div>
        </div>
      )}

      {/* Contenido */}
      {activeTab === 'view' && (
        <CalendarView events={events} config={config} loading={loading} />
      )}

      {activeTab === 'events' && (
        <CalendarEventsList
          events={events}
          loading={loading}
          error={error}
          canManage={canManage}
          onCreate={createEvent}
          onUpdate={updateEvent}
          onDelete={deleteEvent}
        />
      )}

      {activeTab === 'config' && (
        <CalendarConfig
          config={config}
          loading={loading}
          error={error}
          canManage={canManage}
          onSave={saveConfig}
        />
      )}
    </div>
  );
}
